import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blogPostSection: 0,
  keywordListsSection: 0,
  keywordOverviewSection: 0,
  competitorAnalysisSection: 0,
  bulkKeywordDifficultyReduxData: null,
  relatedKeywordsReduxData: null,
  keywordOverviewFilters: {
    searchVolume: null,
    kd: null,
    position: null,
    intent: null,
    keywordGoldenRation: null,
    wordCount: null
  },
  keywordOverviewKeyword: null,
  keywordOverviewMatch: false,
  keywordOverviewLoader: false,
  keywordOverviewTableLoader: false,
  keywordOverviewLocation: '',
  competitorDetailsReduxData: null,
  topOrganicKeyword: {},
  competitorAnalysisLoader: false,
  competitorAnalysisTableLoader: false,
  competitorAnalysisFilters: {
    searchVolume: null,
    traffic: null,
    intent: null,
    backLinks: null,
    position: null,
    kd: null
  },
  competitorAnalysisUrl: null,
  competitorAnalysisLocation: '',
  searchesDetails: [],
  closeSnackBar: false,
  keywordOverviewFilteredData: {},
  competitorAnalysisFilteredData: {},
  newKeyword: '',
  isLimitExhausted: null,
  blogPostLoader: null,
  blogPostGsc: null,
  blogPostGenerateIdeas: null,
  selectedSearches: null,
  openCreditModal: null,
  keywordTrackingSection: null,
  keywordTrackCountryArray: [],
  keywordTrackKeywordsArray: [],
  keywordTrackingDevice: 'desktop',
  keywordTrackingMonitoring: 'Every Month',
  isDeleteMultipleKeyword: null,
  keywordTrackingCardsDataRedux: null,
  keywordTrackingTableDataRedux: null,
  competitorAnalyzeId: null,
  previousSearchLocationCode: null,
  previousSearchId: null,
  lastUpdatedDate: null,
  keywordOverviewId: null,
  isKeywordDataUpdated: null,
  isCompetitorDataUpdated: null,
  addedKeywordTrackingData: [],
  keywordTrackingDuplicateData: [],
  newLocationKeywordsCountRedux: 0,
  existingLocationNamesRedux: [],
  keywordTrackingDetails: null,
  isNoCountrySelected: false,
  getKeywordDetailsFromTooltip: [],
  isAgencyRecommend: null,
  isKeywordLimitError: null,
  compareAvgCalculationDetails: null,
  keywordExplorerSearchedLocationCode: null,
  selectedKeywordRows: [],
  keywordListId: null,
  keywordListSnackBar: null,
  keywordListsFilters: {
    searchVolume: null,
    kd: null,
    position: null,
    intent: null,
    keywordGoldenRation: null,
    wordCount: null
  },
  keywordLists: [],
  keywordListsFilteredData: [],
  keywordListsDetailsFilteredData: [],
  keywordListsDetails: [],
  keywordTrackingStartDate: null,
  keywordTrackingEndDate: null,
  isListCreated: null,
  isRefreshList: null,
  keywordListNameRedux: '',
  isAgencyUpgrade: false,
  backLinkSection: 0,
  selectedCompetitorRows: [],
  backLinkFilters: {
    searchVolume: null,
    kd: null,
    position: null,
    intent: null,
    keywordGoldenRation: null,
    wordCount: null,
    spamScore: null
  },
  backLinkData: [],
  backLinkFilteredData: [],
  previousCompetitorLocationCode: null,
  listNameRedux: null,
  isGoToList: null,
  emailsRedux: null,
  localSeoSection: 0,
  keywordTrackingPdfLoader: null,
  isUnlocked: null,
  isUnlockedBackLink: null,
  keywordTrackingMonitoringDetails: null,
  listFolderDetails: null,
  listFolderName: null,
  isNotValidKeyword: null,
  monitoringAllDates: []
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name siteAuditSlice
 * @type {Slice}
 */
// Action functions declaration
export const keywordResearchSlice = createSlice({
  name: 'keywordResearch',
  initialState,
  reducers: {
    /**
     * Set the details of all sites.
     *
     * @function
     * @name setShowSection
     * @param {Object} state - The current state.
     * @param {Object} actions - The action with payload.
     */
    setBlogPostSection: (state, action) => {
      // Add a new reducer to set itemId
      state.blogPostSection = action.payload;
    },
    setKeywordListsSection: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListsSection = action.payload;
    },
    setKeywordOverviewSection: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewSection = action.payload;
    },
    setCompetitorAnalysisSection: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisSection = action.payload;
    },
    setBulkKeywordDifficultyReduxData: (state, action) => {
      // Add a new reducer to set itemId
      state.bulkKeywordDifficultyReduxData = action.payload;
    },
    setRelatedKeywordsReduxData: (state, action) => {
      // Add a new reducer to set itemId
      state.relatedKeywordsReduxData = action.payload;
    },
    setKeywordOverviewFilters: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewFilters = action.payload;
    },
    setCompetitorDetailsReduxData: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorDetailsReduxData = action.payload;
    },
    setKeywordOverviewKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewKeyword = action.payload;
    },
    setKeywordOverviewLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewLoader = action.payload;
    },
    setKeywordOverviewTableLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewTableLoader = action.payload;
    },
    setKeywordOverviewLocation: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewLocation = action.payload;
    },
    setTopOrganicKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.topOrganicKeyword = action.payload;
    },
    setCompetitorAnalysisTableLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisTableLoader = action.payload;
    },
    setCompetitorAnalysisLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisLoader = action.payload;
    },
    setCompetitorAnalysisFilters: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisFilters = action.payload;
    },
    setCompetitorAnalysisUrl: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisUrl = action.payload;
    },
    setCompetitorAnalysisLocation: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisLocation = action.payload;
    },
    setSearchesDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.searchesDetails = action.payload;
    },
    setSnackBarClose: (state, action) => {
      // Add a new reducer to set itemId
      state.closeSnackBar = action.payload;
    },
    setKeywordOverviewFilteredData: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewFilteredData = action.payload;
    },
    setCompetitorAnalysisFilteredData: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalysisFilteredData = action.payload;
    },
    setNewKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.newKeyword = action.payload;
    },
    setIsLimitExhausted: (state, action) => {
      // Add a new reducer to set itemId
      state.isLimitExhausted = action.payload;
    },
    setBlogPostLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.blogPostLoader = action.payload;
    },
    setBlogPostGsc: (state, action) => {
      // Add a new reducer to set itemId
      state.blogPostGsc = action.payload;
    },
    setBlogPostGenerateIdeas: (state, action) => {
      // Add a new reducer to set itemId
      state.blogPostGenerateIdeas = action.payload;
    },
    setSelectedSearches: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedSearches = action.payload;
    },
    setOpenSearchCreditModal: (state, action) => {
      // Add a new reducer to set itemId
      state.openCreditModal = action.payload;
    },
    setKeywordTrackingSection: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingSection = action.payload;
    },
    setKeywordTrackCountryArray: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackCountryArray = action.payload;
    },
    setKeywordTrackKeywordsArray: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackKeywordsArray = action.payload;
    },
    setKeywordTrackingDevice: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingDevice = action.payload;
    },
    setKeywordTrackingMonitoring: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingMonitoring = action.payload;
    },
    setIsDeleteMultipleKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.isDeleteMultipleKeyword = action.payload;
    },
    setKeywordTrackingCardsDataRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingCardsDataRedux = action.payload;
    },
    setKeywordTrackingTableDataRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingTableDataRedux = action.payload;
    },
    setCompetitorAnalysisId: (state, action) => {
      // Add a new reducer to set itemId
      state.competitorAnalyzeId = action.payload;
    },
    setPreviousSearchLocationCode: (state, action) => {
      // Add a new reducer to set itemId
      state.previousSearchLocationCode = action.payload;
    },
    setPreviousSearchId: (state, action) => {
      // Add a new reducer to set itemId
      state.previousSearchId = action.payload;
    },
    setLastUpdatedDate: (state, action) => {
      // Add a new reducer to set itemId
      state.lastUpdatedDate = action.payload;
    },
    setKeywordOverviewId: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewId = action.payload;
    },
    setIsKeywordDataUpdated: (state, action) => {
      // Add a new reducer to set itemId
      state.isKeywordDataUpdated = action.payload;
    },
    setIsCompetitorDataUpdated: (state, action) => {
      // Add a new reducer to set itemId
      state.isCompetitorDataUpdated = action.payload;
    },
    setAddedKeywordTrackingData: (state, action) => {
      // Add a new reducer to set itemId
      state.addedKeywordTrackingData = action.payload;
    },
    setKeywordTrackingDuplicateData: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingDuplicateData = action.payload;
    },
    setNewLocationKeywordsCountRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.newLocationKeywordsCountRedux = action.payload;
    },
    setExistingLocationNamesRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.existingLocationNamesRedux = action.payload;
    },
    setKeywordTrackingDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingDetails = action.payload;
    },
    setIsNoCountrySelected: (state, action) => {
      // Add a new reducer to set itemId
      state.isNoCountrySelected = action.payload;
    },
    setGetKeywordDetailsFromTooltip: (state, action) => {
      // Add a new reducer to set itemId
      state.getKeywordDetailsFromTooltip = action.payload;
    },
    setIsAgencyRecommend: (state, action) => {
      // Add a new reducer to set itemId
      state.isAgencyRecommend = action.payload;
    },
    setIsKeywordLimitError: (state, action) => {
      // Add a new reducer to set itemId
      state.isKeywordLimitError = action.payload;
    },
    setCompareAvgCalculationDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.compareAvgCalculationDetails = action.payload;
    },
    setKeywordExplorerSearchedLocationCode: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordExplorerSearchedLocationCode = action.payload;
    },
    setSelectedKeywordRows: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedKeywordRows = action.payload;
    },
    setKeywordListId: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListId = action.payload;
    },
    setKeywordListSnackBar: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListSnackBar = action.payload;
    },
    setKeywordListsFilters: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListsFilters = action.payload;
    },
    setKeywordLists: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordLists = action.payload;
    },
    setKeywordListsFilteredData: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListsFilteredData = action.payload;
    },
    setKeywordListsDetailsFilteredData: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListsDetailsFilteredData = action.payload;
    },
    setKeywordListsDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListsDetails = action.payload;
    },
    setKeywordTrackingStartDate: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingStartDate = action.payload;
    },
    setKeywordTrackingEndDate: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingEndDate = action.payload;
    },
    setIsListCreatedRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.isListCreated = action.payload;
    },
    setIsRefreshList: (state, action) => {
      // Add a new reducer to set itemId
      state.isRefreshList = action.payload;
    },
    setKeywordListNameRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordListNameRedux = action.payload;
    },
    setIsAgencyUpgrade: (state, action) => {
      // Add a new reducer to set itemId
      state.isAgencyUpgrade = action.payload;
    },
    setBackLinkSection: (state, action) => {
      // Add a new reducer to set itemId
      state.backLinkSection = action.payload;
    },
    setSelectedCompetitorRows: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedCompetitorRows = action.payload;
    },
    setBackLinkFilters: (state, action) => {
      // Add a new reducer to set itemId
      state.backLinkFilters = action.payload;
    },
    setbackLinkData: (state, action) => {
      // Add a new reducer to set itemId
      state.backLinkData = action.payload;
    },
    setbackLinkFilteredData: (state, action) => {
      // Add a new reducer to set itemId
      state.backLinkFilteredData = action.payload;
    },
    setPreviousCompetitorLocationCode: (state, action) => {
      // Add a new reducer to set itemId
      state.previousCompetitorLocationCode = action.payload;
    },
    setListNameRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.listNameRedux = action.payload;
    },
    setIsGoToList: (state, action) => {
      // Add a new reducer to set itemId
      state.isGoToList = action.payload;
    },
    setEmailsRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.emailsRedux = action.payload;
    },
    setLocalSeoSection: (state, action) => {
      // Add a new reducer to set itemId
      state.localSeoSection = action.payload;
    },
    setKeywordTrackingPdfLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingPdfLoader = action.payload;
    },
    setIsUnlocked: (state, action) => {
      // Add a new reducer to set itemId
      state.isUnlocked = action.payload;
    },
    setIsUnlockedBackLink: (state, action) => {
      // Add a new reducer to set itemId
      state.isUnlockedBackLink = action.payload;
    },
    setKeywordTrackingMonitoringDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordTrackingMonitoringDetails = action.payload;
    },

    setKeywordExactMatch: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordOverviewMatch = action.payload;
    },
    setListFolderDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.listFolderDetails = action.payload;
    },
    setListFolderName: (state, action) => {
      // Add a new reducer to set itemId
      state.listFolderName = action.payload;
    },
    setIsNotValidKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.isNotValidKeyword = action.payload;
    },
    setMonitoringDates: (state, action) => {
      // Add a new reducer to set itemId
      state.monitoringAllDates = action.payload;
    },
    /**
     * Clean up and reset the state to its initial values.
     *
     * @function
     * @name cleanupInitialState
     */
    cleanupKeywordInitialState: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  setBlogPostSection,
  setKeywordListsSection,
  setKeywordOverviewSection,
  setCompetitorAnalysisSection,
  setBulkKeywordDifficultyReduxData,
  setRelatedKeywordsReduxData,
  setKeywordOverviewFilters,
  setKeywordOverviewKeyword,
  setKeywordOverviewLoader,
  setKeywordOverviewTableLoader,
  setKeywordOverviewLocation,
  setCompetitorDetailsReduxData,
  setTopOrganicKeyword,
  setCompetitorAnalysisTableLoader,
  setCompetitorAnalysisLoader,
  setCompetitorAnalysisFilters,
  setCompetitorAnalysisUrl,
  setCompetitorAnalysisLocation,
  setSearchesDetails,
  setSnackBarClose,
  setKeywordOverviewFilteredData,
  setCompetitorAnalysisFilteredData,
  setNewKeyword,
  cleanupKeywordInitialState,
  setIsLimitExhausted,
  setBlogPostLoader,
  setBlogPostGsc,
  setBlogPostGenerateIdeas,
  setSelectedSearches,
  setOpenSearchCreditModal,
  setKeywordTrackingSection,
  setKeywordTrackCountryArray,
  setKeywordTrackKeywordsArray,
  setKeywordTrackingDevice,
  setKeywordTrackingMonitoring,
  setIsDeleteMultipleKeyword,
  setKeywordTrackingCardsDataRedux,
  setKeywordTrackingTableDataRedux,
  setCompetitorAnalysisId,
  setPreviousSearchLocationCode,
  setPreviousSearchId,
  setLastUpdatedDate,
  setKeywordOverviewId,
  setIsKeywordDataUpdated,
  setIsCompetitorDataUpdated,
  setAddedKeywordTrackingData,
  setKeywordTrackingDuplicateData,
  setNewLocationKeywordsCountRedux,
  setExistingLocationNamesRedux,
  setKeywordTrackingDetails,
  setIsNoCountrySelected,
  setGetKeywordDetailsFromTooltip,
  setIsAgencyRecommend,
  setIsKeywordLimitError,
  setCompareAvgCalculationDetails,
  setKeywordExplorerSearchedLocationCode,
  setSelectedKeywordRows,
  setKeywordListId,
  setKeywordListSnackBar,
  setKeywordListsFilters,
  setKeywordLists,
  setKeywordListsFilteredData,
  setKeywordListsDetailsFilteredData,
  setKeywordListsDetails,
  setKeywordTrackingStartDate,
  setKeywordTrackingEndDate,
  setIsListCreatedRedux,
  setIsRefreshList,
  setKeywordListNameRedux,
  setIsAgencyUpgrade,
  setBackLinkSection,
  setSelectedCompetitorRows,
  setBackLinkFilters,
  setbackLinkData,
  setbackLinkFilteredData,
  setPreviousCompetitorLocationCode,
  setListNameRedux,
  setIsGoToList,
  setEmailsRedux,
  setLocalSeoSection,
  setKeywordTrackingPdfLoader,
  setIsUnlocked,
  setIsUnlockedBackLink,
  setKeywordTrackingMonitoringDetails,
  setKeywordExactMatch,
  setListFolderDetails,
  setListFolderName,
  setIsNotValidKeyword,
  setMonitoringDates
} = keywordResearchSlice.actions;

export default keywordResearchSlice.reducer;
